<div class="wrap-help-page-banner pt10" @click="workDelete"><div class="f fh"><span class="bold pb8">お仕事を削除する</span></div></div>